export const IMAGE_FORMAT = 'image/png';

export const LABELS = {
  CLEAR_BUTTON_LABEL: 'Clear',
  PLACEHOLDER: 'Draw signature here',
};
